module.exports = __webpack_public_path__ + "img/magnify.ea593998.svg";